import React from 'react';
import cveImg from '../../../assets/img/cve.png';
import imgElon from '../../../assets/img/hackerMusk.png';
import iotImg from '../../../assets/img/iot.jpg';
import layer8Img from '../../../assets/img/layer8.jpg';

export default function Threats() {
  const styles = {
    heading: {
      color: 'white',
      fontSize: '2.5em',
      marginBottom: '30px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
    },
    threatLayout: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '40px',
      maxWidth: '100%',
      margin: '0 auto',
      padding: '0 20px'
    },
    threatImage: {
      width: '350px',
      height: '250px',
      borderRadius: '10px',
      objectFit: 'cover',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      flexShrink: 0
    },
    threatContent: {
      flex: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '10px',
      padding: '25px',
      border: '1px solid rgba(78, 205, 196, 0.3)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      maxWidth: 'calc(100% - 390px)'
    },
    threatTitle: {
      color: '#4ecdc4',
      fontSize: '1.6em',
      fontWeight: 'bold',
      marginBottom: '15px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    threatDescription: {
      color: 'white',
      fontSize: '1em',
      lineHeight: '1.5',
      marginBottom: '20px'
    },
    threatLevel: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid rgba(78, 205, 196, 0.3)',
      marginBottom: '15px'
    },
    levelBadge: {
      backgroundColor: '#ff6b6b',
      color: 'white',
      padding: '6px 12px',
      borderRadius: '15px',
      fontSize: '0.9em',
      fontWeight: 'bold',
      display: 'inline-block',
      marginBottom: '8px'
    },
    levelSource: {
      color: '#4ecdc4',
      fontSize: '0.8em',
      textDecoration: 'underline',
      cursor: 'pointer',
      display: 'block'
    },
    threatStats: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid rgba(78, 205, 196, 0.3)',
      marginBottom: '15px'
    },
    statNumber: {
      color: '#ff6b6b',
      fontSize: '1.4em',
      fontWeight: 'bold',
      marginBottom: '3px'
    },
    statLabel: {
      color: 'white',
      fontSize: '0.9em',
      marginBottom: '3px'
    },
    statSource: {
      color: '#4ecdc4',
      fontSize: '0.8em',
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    evolutionSection: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '30px',
      borderRadius: '15px',
      margin: '30px auto',
      maxWidth: '1000px',
      border: '2px solid rgba(78, 205, 196, 0.3)'
    },
    evolutionTitle: {
      color: '#4ecdc4',
      fontSize: '1.8em',
      textAlign: 'center',
      marginBottom: '20px'
    },
    evolutionCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      padding: '20px',
      borderRadius: '10px',
      margin: '15px 0',
      border: '1px solid rgba(78, 205, 196, 0.2)',
      transition: 'all 0.3s ease'
    },
    evolutionDescription: {
      color: 'white',
      fontSize: '1em',
      lineHeight: '1.4',
      marginBottom: '15px'
    },
    evolutionStats: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    statBadge: {
      backgroundColor: '#4ecdc4',
      color: 'white',
      padding: '5px 10px',
      borderRadius: '15px',
      fontSize: '0.9em',
      fontWeight: 'bold'
    }
  };

  const threatsData = [
    {
      title: 'Menaces internes',
      description:
        "Les menaces internes, qu'elles soient intentionnelles ou accidentelles, représentent un risque important. Les employés ont parfois accès à des informations sensibles.",
      img: layer8Img,
      level: 'Élevé',
      levelSource: 'Verizon DBIR 2024',
      levelUrl: 'https://www.verizon.com/business/resources/reports/dbir/',
      icon: '👥',
      examples: ['Erreurs humaines', 'Accès non autorisé', 'Sabotage interne'],
      stats: {
        percentage: '22%',
        percentageSource: 'Verizon DBIR 2024',
        percentageUrl:
          'https://www.verizon.com/business/resources/reports/dbir/'
      }
    },
    {
      title: 'Menaces externes',
      description:
        'Les attaquants externes utilisent diverses techniques pour compromettre les systèmes et voler des données sensibles.',
      img: imgElon,
      level: 'Critique',
      levelSource: 'IBM X-Force Threat Intelligence',
      levelUrl: 'https://www.ibm.com/security/xforce',
      icon: '🎯',
      examples: [
        'Espionnage industriel',
        'Enjeux politiques',
        'Motivation financière'
      ],
      stats: {
        percentage: '78%',
        percentageSource: 'Verizon DBIR 2024',
        percentageUrl:
          'https://www.verizon.com/business/resources/reports/dbir/'
      }
    },
    {
      title: 'Vulnérabilités logicielles',
      description:
        'Les vulnérabilités dans les logiciels et applications sont exploitées par les attaquants pour compromettre des systèmes.',
      img: cveImg,
      level: 'Très élevé',
      levelSource: 'CVE Database',
      levelUrl: 'https://cve.mitre.org/',
      icon: '🐛',
      examples: ['CVE', 'Zero-day', 'Mises à jour manquantes'],
      stats: {
        cveCount: '25,000+',
        cveSource: 'CVE Database 2024',
        cveUrl: 'https://cve.mitre.org/'
      }
    },
    {
      title: 'Complexité des infrastructures',
      description:
        "L'architecture de plus en plus complexe des systèmes informatiques augmente la surface d'attaque.",
      img: iotImg,
      level: 'Élevé',
      levelSource: 'Gartner Research',
      levelUrl: 'https://www.gartner.com/',
      icon: '🏗️',
      examples: ['Cloud', 'IoT', 'Containers'],
      stats: {
        iotDevices: '75B+',
        iotSource: 'Gartner 2024',
        iotUrl: 'https://www.gartner.com/'
      }
    }
  ];

  const evolutionData = [
    {
      title: 'IA générative',
      description:
        "Deepfakes, phishing automatisé, code malveillant généré par l'IA",
      impact: '+135%',
      year: '2024'
    },
    {
      title: 'Supply chain',
      description:
        "Attaques sur les dépendances logicielles et la chaîne d'approvisionnement",
      impact: '+78%',
      year: '2024'
    },
    {
      title: 'Cloud native',
      description:
        "Containers, Kubernetes, serverless - nouvelles surfaces d'attaque",
      impact: '+92%',
      year: '2024'
    },
    {
      title: '5G/IoT',
      description: 'Prolifération des objets connectés et des réseaux 5G',
      impact: '+200%',
      year: '2024'
    },
    {
      title: 'Ransomware-as-a-Service',
      description: 'Commercialisation des attaques ransomware',
      impact: '+156%',
      year: '2024'
    },
    {
      title: 'APT (Advanced Persistent Threats)',
      description: 'Groupes étatiques sophistiqués et menaces persistantes',
      impact: '+45%',
      year: '2024'
    }
  ];

  return (
    <section>
      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>
          <span role="img" aria-label="Warning">
            ⚠️
          </span>{' '}
          Les Menaces cybersécurité
        </h1>
      </section>

      {threatsData.map((threat, idx) => (
        <section key={idx}>
          <div style={styles.threatLayout}>
            <img
              src={threat.img}
              alt={threat.title}
              style={styles.threatImage}
            />
            <div style={styles.threatContent}>
              <h2 style={styles.threatTitle}>
                <span role="img" aria-label="Icon">
                  {threat.icon}
                </span>{' '}
                {threat.title}
              </h2>
              <p style={styles.threatDescription}>{threat.description}</p>

              <div style={styles.threatLevel}>
                <div style={styles.levelBadge}>Niveau: {threat.level}</div>
                <div
                  style={styles.levelSource}
                  onClick={() => window.open(threat.levelUrl, '_blank')}
                  title="Cliquer pour voir la source">
                  {threat.levelSource}
                </div>
              </div>

              {threat.stats && (
                <div style={styles.threatStats}>
                  {threat.stats.percentage && (
                    <>
                      <div style={styles.statNumber}>
                        {threat.stats.percentage}
                      </div>
                      <div style={styles.statLabel}>des incidents</div>
                      <div
                        style={styles.statSource}
                        onClick={() =>
                          window.open(threat.stats.percentageUrl, '_blank')
                        }
                        title="Cliquer pour voir la source">
                        {threat.stats.percentageSource}
                      </div>
                    </>
                  )}
                  {threat.stats.cveCount && (
                    <>
                      <div style={styles.statNumber}>
                        {threat.stats.cveCount}
                      </div>
                      <div style={styles.statLabel}>
                        vulnérabilités découvertes
                      </div>
                      <div
                        style={styles.statSource}
                        onClick={() =>
                          window.open(threat.stats.cveUrl, '_blank')
                        }
                        title="Cliquer pour voir la source">
                        {threat.stats.cveSource}
                      </div>
                    </>
                  )}
                  {threat.stats.iotDevices && (
                    <>
                      <div style={styles.statNumber}>
                        {threat.stats.iotDevices}
                      </div>
                      <div style={styles.statLabel}>objets connectés</div>
                      <div
                        style={styles.statSource}
                        onClick={() =>
                          window.open(threat.stats.iotUrl, '_blank')
                        }
                        title="Cliquer pour voir la source">
                        {threat.stats.iotSource}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>
      ))}

      <section>
        <div style={styles.evolutionSection}>
          <h2 style={styles.evolutionTitle}>
            <span role="img" aria-label="Rocket">
              🚀
            </span>{' '}
            Évolution des Menaces 2024
          </h2>
          <p
            style={{
              color: 'white',
              textAlign: 'center',
              marginBottom: '30px'
            }}>
            Les nouvelles menaces émergentes et l'évolution des attaquants
          </p>

          <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {evolutionData.map((evolution, idx) => (
              <div key={idx} style={styles.evolutionCard}>
                <div style={styles.evolutionTitle}>{evolution.title}</div>
                <div style={styles.evolutionDescription}>
                  {evolution.description}
                </div>
                <div style={styles.evolutionStats}>
                  <div style={styles.statBadge}>
                    <span role="img" aria-label="Trending up">
                      📈
                    </span>{' '}
                    {evolution.impact}
                  </div>
                  <div style={styles.statBadge}>
                    <span role="img" aria-label="Calendar">
                      📅
                    </span>{' '}
                    {evolution.year}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
}
